module.exports = __webpack_public_path__ + "static/media/info-tooltip-default.1d9b4e6a.svg";